export default __webpack_public_path__ + "static/4-8ac53c4f99d7d891ff0a5bbf2a8789a4.png";